<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" :rules="rules" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('base_organDialog.shang_ji_bu_men')">
              <el-input v-model="form.parentName" placeholder="" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_organDialog.bu_men_ming_cheng')" prop="departmentName">
              <el-input v-model="form.departmentName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_organDialog.bu_men_jian_cheng')" prop="departmentShort">
              <el-input v-model="form.departmentShort" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_organDialog.lian_xi_ren')" prop="contactName">
              <el-input v-model="form.contactName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_organDialog.lian_xi_ren_dian_hua')" prop="contactPhone">
              <el-input v-model="form.contactPhone" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_organDialog.bu_men_miao_shu')" prop="departmentDesc">
              <el-input v-model="form.departmentDesc" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveOrgan">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        orgId: '',
        parentId: '',
        parentName: '',
        departmentId: '',
        departmentName: '',
        departmentPath: '',
        departmentShort: '',
        contactName: '',
        contactPhone: '',
        departmentDesc: '',
        showOrder: '',
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        departmentName: [
          {
            type: 'string',
            required: true,
            message: this.$t('base_organDialog.bmmcbnwk'),
          },
          {
            type: 'string',
            max: 40,
            message: this.$t('Common.com_rules_length_max', [40]),
          },
        ],
        departmentShort: [
          {
            type: 'string',
            required: true,
            message: this.$t('base_organDialog.bmjcbnwk'),
          },
          {
            max: 20,
            type: 'string',
            message: this.$t('Common.com_rules_length_max', [20]),
          },
        ],
        departmentDesc: {
          max: 20,
          type: 'string',
          message: this.$t('Common.com_rules_length_max', [20]),
        },
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.form.orgId = this.model.orgId;
      if (this.model.type === 'add') {
        this.form.parentId = this.model.bizId;
        this.form.parentName = this.model.bizName;
      }
      if (this.model.type === 'edit') {
        this.getParentOrgan();
      }
    },
    // 获取部门信息
    getParentOrgan: function () {
      this.$getJSON(`${apis.Department}/${this.model.bizId}`).then((res) => {
        const parentData = res.data;
        this.$setFormatData(this.form, parentData);
      });
    },
    // 确认保存用户
    saveOrgan: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveAddOrgan();
        }
        if (this.model.type === 'edit') {
          this.saveEditOrgan();
        }
      });
    },
    // 保存新增用户
    saveAddOrgan: function () {
      this.$postJSON(apis.DepartmentAdd, this.form, true).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存编辑用户
    saveEditOrgan: function () {
      this.$postJSON(apis.DepartmentUpdate, this.form, true).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss"></style>
